import './SendToEtpExecutor.scss';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { ISendToEtpModel } from '@models/document/actionsExecution/ISendToEtpModel';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import InputControl from '@srm/ui/controls/InputControl';
import { requiredTextRules } from '@srm/ui/lib/requiredTextRules';
import { ISendToEtpExecutorProps } from './ISendToEtpExecutorProps';
import { ISendToEtpFormData } from './ISendToEtpFormData';
import { useUnsavedFormInput } from '@srm/ui/hooks/useUnsavedFormInput';

export const SendToEtpExecutorModal: React.FC<ISendToEtpExecutorProps> = (props: ISendToEtpExecutorProps) => {
    // Подготовка (модель) и отправка — разные состояния: подготовку можно бросить закрытием
    // окна, отправку — нет.
    const [loading, setLoading] = useState<boolean>(true);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [success, setSuccess] = useState<boolean>(false);
    const [errorText, setErrorText] = useState<string>();
    const [successText, setSuccessText] = useState<string>();
    const [etpOrgCodeRequired, setEtpOrgCodeRequired] = useState<boolean>();
    const [authRequired, setAuthRequired] = useState<boolean>();
    const formState = useForm<ISendToEtpFormData>({
        mode: 'onBlur', // "onChange"
    });
    const hasUnsavedInput = useUnsavedFormInput(formState);

    const service = new DocumentExecutionService(props.docId);

    useEffect(() => {
        // Закрытое окно ответ подготовки не применяет.
        let ignore = false;
        // Модель данных
        setLoading(true);
        service
            .getSendToEtpModel(props.actionKey)
            .then((result) => {
                if (ignore) return;
                if (result.data) {
                    setEtpOrgCodeRequired(result.data.etpOrgCodeRequired);
                    setAuthRequired(result.data.authRequired);
                    formState.reset({
                        login: result.data.login,
                        password: result.data.password,
                        etpOrgCode: result.data.etpOrgCode,
                    });
                }
            })
            .catch((error) => {
                if (!ignore) setErrorText(error);
            })
            .finally(() => {
                if (!ignore) setLoading(false);
            });
        return () => {
            ignore = true;
        };
    }, []);

    const onSubmit = (form: ISendToEtpFormData) => {
        // Отправить данные
        setIsSubmitting(true);
        setErrorText('');
        setSuccessText('');
        const sendToEtpData: ISendToEtpModel = {
            login: form.login,
            password: form.password,
            etpOrgCode: form.etpOrgCode,
        };

        return service
            .sendToEtp(props.actionKey, sendToEtpData)
            .then((dto) => {
                setSuccessText(dto.data);
                setSuccess(true);
                //props.completeHandler && props.completeHandler(true);
            })
            .catch((error) => setErrorText(error))
            .finally(() => setIsSubmitting(false));
    };

    const modalContainerProps: IModalContainerProps = {
        header: props.message,
        size: props.modalSize,
        showOkButton: !success,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        onCancel: () => {
            props.completeHandler && props.completeHandler(success);
        },
        errorText: errorText,
        successText: successText,
        formMethods: formState,
        onSubmit: onSubmit,
        okButtonDisabled: false,
        loading: loading || isSubmitting,
        closeDisabled: isSubmitting,
        hasUnsavedInput: () => !success && hasUnsavedInput(),
    };

    return (
        <ModalContainer {...modalContainerProps}>
            {!success && etpOrgCodeRequired && (
                <InputControl
                    label="Код организации"
                    name="etpOrgCode"
                    required={etpOrgCodeRequired}
                    rules={etpOrgCodeRequired ? requiredTextRules() : undefined}
                    control={formState.control}
                />
            )}

            {!success && authRequired && (
                <InputControl
                    label="Логин"
                    name="login"
                    autoComplete="off"
                    required={authRequired}
                    rules={authRequired ? requiredTextRules() : undefined}
                    control={formState.control}
                />
            )}

            {!success && authRequired && (
                <InputControl
                    label="Пароль"
                    name="password"
                    autoComplete="off"
                    type="password"
                    required={authRequired}
                    rules={authRequired ? requiredTextRules() : undefined}
                    control={formState.control}
                />
            )}
        </ModalContainer>
    );
};
